import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";

import Hidden from "@material-ui/core/Hidden";
import { withStyles } from "@material-ui/core/styles";

import ProgressBar from "./ProgressBar";
import NavigationButton from "../NavigationButton";
import Copyright from "../Copyright";
import { navigatePrevious, navigateNext } from "../../state/actions/navigate";
import { RTL_LANGUAGES } from "../../constants";
import getSelectedLocale from "../../state/selectors/i18n";

const styles = theme => ({
  footer: {
    height: "90px",
    background: "#ffffff",
    boxShadow: "0px 4px 7px 0px rgba(0, 0, 0, 0.34)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "fixed",
    bottom: "0",
    left: "0",
    right: "0",
    zIndex: theme.zIndex.footer,
    [theme.breakpoints.down("sm")]: {
      height: "82px"
    },
    "@media (max-width: 320px)": {
      height: "65px"
    }
  },
  buttonContainer: {
    display: "none",
    "@media only screen and (max-width: 1280px) and (orientation: landscape)": {
      display: "flex",
      gap: "4px",
      padding: "0 10px"
    },
    [theme.breakpoints.down("sm")]: {
      display: "flex"
    }
  },
});

const Footer = ({ classes, onNext, onPrevious, locale }) => {
  const isRtl = useMemo(() => {
    return RTL_LANGUAGES.includes(locale);
  }, [locale]);

  return (
    <footer className={classes.footer}>
      <ProgressBar />
      <div
        className={classes.buttonContainer}
        style={{ flexDirection: isRtl ? "row-reverse" : "row" }}
      >
        <NavigationButton
          className={classes.button}
          onClick={isRtl ? onNext : onPrevious}
        />
        <NavigationButton
          className={classes.button}
          onClick={isRtl ? onPrevious : onNext}
          next
        />
      </div>
      <Hidden smDown>
        <Copyright />
      </Hidden>
    </footer>
  );
};

Footer.propTypes = {
  classes: PropTypes.shape().isRequired,
  onPrevious: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired
};

export { Footer as Component };

const mapDispatchToProps = dispatch => ({
  onNext: () => dispatch(navigateNext()),
  onPrevious: () => dispatch(navigatePrevious())
});


const mapStateToProps = state => ({
  locale: getSelectedLocale(state),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Footer));
